angular.module("identifiers")

    .controller("IdentifiersListCtrl", ['$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$filter', '$state', 'logService',
        function ($rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $filter, $state, logService) {
        
        $rootScope.title = $filter('translate')('identifiers.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('identifiers.title') }
        ];

        $scope.gridOptions = {
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            pdfTitle: $filter('translate')('identifiers.title'),
            columnDefs: [
              { name: 'id', visible: false, exporterSuppressExport: true },              
              { name: 'FK_identifiers_identifiers_types.name', displayName: $filter('translate')('identifiers.type'), enableFiltering: true, enableHiding: false },
              { name: 'value', displayName: $filter('translate')('identifiers.value'), enableFiltering: true, enableHiding: false },
              { name: 'description', displayName: $filter('translate')('identifiers.description'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, exporterSuppressExport: true, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('groups.edit'), action: 'ui-sref="identifiers.edit({id:row.entity.id})"', cssIconClass: "fa fa-pencil" },
                      { title: $filter('translate')('groups.delete'), action: 'ng-if="row.entity.type!=\'ALERT\'" ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.value);"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right"})
              },              
            ],
            getData: function (options) {
                return Restangular.all('Identifiers').getList(options);
            }

        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("identifiers.edit", { id: rowEntity.id });
        }


        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('groups.delete'),
                message: $filter('translate')('identifiers.delete_message')+" "+ $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Identifiers', $scope.id).remove().then(function () {
                        $scope.gridOptions.data =
                             $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                        toastr.success($filter('translate')('identifiers.delete_success'));
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                        alert("Error al borrar")
                    });
                }
            });

        };
    }])

;